// extracted by mini-css-extract-plugin
export default {"subtitle":"subtitle---A53Rx","volumeBadge":"volumeBadge---s4MET","reminderBlockedReason":"reminderBlockedReason---b3upV","reminderSchedule":"reminderSchedule---al3j_"};